export default "__VITE_ASSET__CycI_WNZ__"